module.exports = __webpack_public_path__ + "static/media/veil.69252dfc.mp3";